import React, { Fragment, useContext } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { FollowUp, Favourites, Ideas, Business, Holidays, Important } from '../../../../Constant';
import HistoryClass from './History';
import NoDataFoundClass from './NoDataFound';
import OrgenizationTab from './OrgenizationTab';
import PersonalTab from './PersonalTab';
import ContactAppContext from '../../../../_helper/Contact';

const TabComponent = ({ activeTab }) => {
    const { users } = useContext(ContactAppContext);

    return (
        <Fragment>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                    <PersonalTab users={users} />
                </TabPane>
                <TabPane tabId="2">
                    <OrgenizationTab />
                </TabPane>
                <TabPane tabId="3">
                    <NoDataFoundClass title={" Benefits & Claims Committees"} />
                </TabPane>
				<TabPane tabId="4">
                    <NoDataFoundClass title={" Job Evaluation Committees"} />
                </TabPane>
				<TabPane tabId="5">
                    <NoDataFoundClass title={" Training Evaluation Committees"} />
                </TabPane>
				
                
                <HistoryClass />
            </TabContent>
        </Fragment>
    );
};

export default TabComponent;